import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const DonationCategoryModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default DonationCategoryModule;